export default __webpack_public_path__ + "static/media/WebOS.bdc16ad2.png";